import { CANONICAL_HOST_BY_FIREBASE_HOST } from '@/shared/config/canonicalHosts';

export interface BrowserLocation {
  readonly href: string;
  replace(url: string): void;
}

/** Return the canonical custom-domain URL for a Firebase Hosting URL. */
function canonicalHostingUrl(href: string): string | undefined {
  const target = new URL(href);
  const canonicalHost = CANONICAL_HOST_BY_FIREBASE_HOST[target.hostname];
  if (!canonicalHost) return undefined;

  target.protocol = 'https:';
  target.host = canonicalHost;
  return target.toString();
}

/** Redirect before authentication, analytics, or the upload runtime starts. */
export function redirectLegacyHostingOrigin(location: BrowserLocation): boolean {
  const target = canonicalHostingUrl(location.href);
  if (!target) return false;

  location.replace(target);
  return true;
}
